const input = {
    username: '用戶名',
    password: '密碼',
    email: '電子郵件',
    phone_number: '手機號碼',
    confirm_password: '確認密碼',
    search_region_code: '搜尋區域碼',
    backup_code: '備用碼',
    label_with_optional: '{{label}}（可選）',
};
export default Object.freeze(input);
